var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex h-100 align-center justify-center"},[_c('div',{staticClass:"px-4"},[_vm._v(" Redirecting... ")])])])
}]

export { render, staticRenderFns }